import { Link as LinkR } from 'react-router-dom';
import styled from 'styled-components';

export const Nav = styled.nav`
  background: rgba(9, 8, 14, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.6);
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
  position: sticky;
  top: 0;
  z-index: 1000;
  transition: all 0.3s ease;
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 0 24px;
  max-width: 1200px;
`;

export const NavLogo = styled(LinkR)`
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  cursor: pointer;
`;

export const LogoIcon = styled.div`
  color: #854CE6;
  display: flex;
  align-items: center;
  filter: drop-shadow(0 0 12px rgba(133, 76, 230, 0.6));
`;

export const LogoText = styled.span`
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #ffffff;

  span {
    color: #c084fc;
  }
`;

export const NavItems = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  list-style: none;
  margin: 0;
  padding: 0;

  @media screen and (max-width: 880px) {
    display: none;
  }
`;

export const NavLink = styled.a`
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
  font-size: 14.5px;
  cursor: pointer;
  transition: all 0.25s ease;
  text-decoration: none;
  position: relative;
  padding: 6px 0;

  &::after {
    content: '';
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 0%;
    height: 2px;
    background: linear-gradient(90deg, #854CE6, #c026d3);
    transition: width 0.25s ease;
    border-radius: 2px;
    box-shadow: 0 0 8px rgba(133, 76, 230, 0.6);
  }

  &:hover {
    color: #ffffff;

    &::after {
      width: 100%;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media screen and (max-width: 880px) {
    display: none;
  }
`;

export const ContactNavButton = styled.a`
  background: linear-gradient(135deg, #854CE6 0%, #a855f7 100%);
  color: #ffffff;
  font-size: 13.5px;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 9px 20px;
  border-radius: 9999px;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 18px rgba(133, 76, 230, 0.4);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 24px rgba(133, 76, 230, 0.65);
    filter: brightness(1.1);
  }
`;

export const MobileIcon = styled.div`
  display: none;
  cursor: pointer;
  color: #ffffff;
  font-size: 1.4rem;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 880px) {
    display: flex;
  }
`;

export const MobileMenu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  position: absolute;
  top: 75px;
  left: 0;
  width: 100%;
  padding: 24px 30px 30px 30px;
  background: rgba(9, 8, 14, 0.96);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-bottom: 1px solid rgba(133, 76, 230, 0.3);
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  transform: ${({ isOpen }) => (isOpen ? 'translateY(0)' : 'translateY(-120%)')};
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  pointer-events: ${({ isOpen }) => (isOpen ? 'all' : 'none')};
  z-index: 999;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.6);
`;

export const MobileLink = styled.a`
  color: rgba(255, 255, 255, 0.85);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;

  &:hover {
    color: #c084fc;
    transform: scale(1.05);
  }
`;
